import React, { useEffect, useState } from "react";
import CustomInput from "../../../ui/custom-input";
import { IoCloseOutline } from "react-icons/io5";
import Customform from "../../../ui/custom-form";
import { PulseLoader } from "react-spinners";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import { useDispatch, useSelector } from "react-redux";
import { sendInvitedUsers, UpdateTeamMember } from "../../../api/api";
import axios from "axios";

function AddUser({ onClose }) {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state?.authUser);
  const user_info = data?.data;

  const [useCase, setUseCase] = useState([]);
  const [users, setUsers] = useState([{ name: "", email: "", mobile_no: "" }]);
  const [permissions, setPermissions] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const editUserData = useSelector((state) => state?.PopupReducer?.modal?.data);
  const [loading, setLoading] = useState(false);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  // Restore user data in edit mode
  useEffect(() => {
    if (editUserData) {
      setUsers([
        {
          name: editUserData?.user_name || "",
          email: editUserData?.email || "",
          mobile_no: editUserData?.mobile_number || "",
          // permissions: editUserData?.permissions || [], // ✅ restore saved permissions
          // alerts: editUserData?.alerts || [], // ✅ restore saved alerts
        },
      ]);
    }
  }, [editUserData]);

  // Handle input & checkbox change
  const handleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updatedUsers = [...users];

    if (name === "permissions" || name === "alerts") {
      let updatedArray = updatedUsers[index][name] || [];

      if (checked) {
        updatedArray = [...updatedArray, value];
      } else {
        updatedArray = updatedArray.filter((id) => id !== value);
      }

      updatedUsers[index][name] = updatedArray;
    } else {
      updatedUsers[index][name] = value;
    }

    setUsers(updatedUsers);
  };

  const addNewUserField = () => {
    setUsers([
      ...users,
      { name: "", email: "", mobile_no: "", permissions: [], alerts: [] }, // ✅ always init
    ]);
  };

  const removeUserField = (index) => {
    if (users.length === 1) return;
    const updatedUsers = users.filter((_, i) => i !== index);
    setUsers(updatedUsers);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (editUserData) {
      const formData = new FormData();
      formData.append("user_id", editUserData?._id);
      formData.append("user_name", users[0]?.name || "");
      formData.append("email", users[0]?.email || "");
      formData.append("mobile_number", users[0]?.mobile_no || "");
      formData.append("user_id", user_id);
      formData.append("organization_id", organization_id);
      // formData.append("permissions", JSON.stringify(users[0]?.permissions)); // ✅ include permissions
      // formData.append("alerts", JSON.stringify(users[0]?.alerts)); // ✅ include alerts

      try {
        await UpdateTeamMember(formData);
        handleClose();
      } catch (error) {
        console.log("Update error:", error);
      } finally {
        setLoading(false);
      }
    } else {
      const payload = {
        invited_by: user_info?.user_id,
        organization_id: user_info?.organization_id,
        invite_status: "pending",
        stage_no: 1,
        invite_data: users, 
        user_id,
      };

      try {
        await sendInvitedUsers(payload);
        handleClose();
      } catch (error) {
        console.log("Invite error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Fetch permissions and alerts
  useEffect(() => {
    const fetchPermissionsAndAlerts = async () => {
      try {
        const permissionsResponse = await fetch(
          "https://us2.sourcesoftsolutions.com:5074/permission-types",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer test123securetoken",
            },
          }
        );
        const permissionsData = await permissionsResponse.json();
        setPermissions(permissionsData?.data?.data || []);

        const alertsResponse = await fetch(
          "https://us2.sourcesoftsolutions.com:5074/action-types",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer test123securetoken",
            },
          }
        );
        const alertsData = await alertsResponse.json();
        setAlerts(alertsData?.data || []);
      } catch (error) {
        console.error("Error fetching permissions or alerts:", error);
      }
    };

    fetchPermissionsAndAlerts();
  }, []);

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
    if (onClose) onClose();
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">Invite Users</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          {users?.map((user, index) => (
            <div key={index} className="user-entry mb-4 border p-3 rounded">
              <div className="mb-3">
                <label className="form-label">Name</label>
                <CustomInput
                  name="name"
                  placeholder="Enter name"
                  value={user.name}
                  onChange={(e) => handleChange(index, e)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <CustomInput
                  name="email"
                  placeholder="Enter email"
                  value={user.email}
                  onChange={(e) => handleChange(index, e)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Mobile Number</label>
                <CustomInput
                  name="mobile_no"
                  placeholder="Enter mobile number"
                  value={user.mobile_no}
                  onChange={(e) => handleChange(index, e)}
                />
              </div>
            </div>
          ))}

          <div className="bottomBtn d-flex justify-content-between">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>

            <button
              className="btnSubmit px-4 py-2"
              type="submit"
              disabled={loading}
            >
              {loading ? <PulseLoader color="#fff" size={8} /> : "Send Invites"}
            </button>
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddUser;
